import { Pipe, PipeTransform } from '@angular/core';
import { OnboardingBillingEquipment } from '~core/models/sales-point.models';

@Pipe({
  name: 'onboardingEquipment',
  pure: true,
  standalone: true
})
export class OnboardingEquipmentPipe implements PipeTransform {
  private readonly _map: Record<OnboardingBillingEquipment, string> = {
    [OnboardingBillingEquipment.onboardingEquipmentType]:
      'Equipement de facturation',
    [OnboardingBillingEquipment.billingSoftware]: 'Logiciel de facturation'
  };

  transform(value: OnboardingBillingEquipment | undefined): string {
    if (!value) return 'Inconnu';
    return this._map[value] || value;
  }
}
